var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "v-list form-group", class: _vm.computedListClass },
    [
      _vm.options && _vm.options.length
        ? _vm._l(_vm.options, function (item, idx) {
            return _c(
              "div",
              {
                key: item[_vm.rowKey] || idx,
                staticClass: "v-list__meta",
                class: _vm.computedListItemClass,
                on: {
                  click: function ($event) {
                    return _vm.$emit("click", item)
                  },
                },
              },
              [
                _vm._t("avatar", function () {
                  return [
                    item.avatar
                      ? _c(
                          "div",
                          {
                            staticClass: "meta__avatar",
                            class: _vm._f("getAvatarByField")(
                              item.avatar,
                              "type"
                            ),
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm._f("getAvatarByField")(
                                  item.avatar,
                                  "src"
                                ),
                                alt: "avatar",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
                _c(
                  "div",
                  { staticClass: "meta__content" },
                  [
                    _vm._t("title", function () {
                      return [
                        _c("div", { staticClass: "meta__content-title" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ]
                    }),
                    _vm._t("description", function () {
                      return [
                        _c("div", { staticClass: "meta__content-desc" }, [
                          _vm._v(_vm._s(item.description)),
                        ]),
                      ]
                    }),
                  ],
                  2
                ),
              ],
              2
            )
          })
        : [
            _c(
              "div",
              { staticClass: "v-list__empty-text" },
              [
                _vm._t("empty-text", function () {
                  return [
                    _c("p", { staticClass: "v-list__empty-text--default" }, [
                      _vm._v(_vm._s(_vm.emptyText)),
                    ]),
                  ]
                }),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }